/* eslint-disable import/no-extraneous-dependencies */

import { debounce } from './util';

const stickyHeroButtonBar = (() => {
    const $stickyBar = $('.js-sticky-hero-bar');
    const $mainBannerButton = $('.js-main-button-wrapper');

    function moveStickyBar() {
        if ($stickyBar.length) {
            $stickyBar.appendTo('#main-content'); // move to end of page because of z-index issues
        }
    }

    function checkVisibility() {
        if ($(window).width() <= 767) {
            const rect = $mainBannerButton[0].getBoundingClientRect();
            const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
            const adjustedViewportTop = 0 + headerHeight; // Adjusting the effective top of the viewport

            const isAboveViewport = rect.bottom < adjustedViewportTop; // Button is completely above the adjusted viewport
            const inView = (
                rect.top >= adjustedViewportTop // Use adjusted top instead of 0
                && rect.left >= 0
                && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
                && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );

            if (inView || !isAboveViewport) {
                $stickyBar.removeClass('visible');
            } else {
                $stickyBar.addClass('visible');
            }
        } else {
            $stickyBar.removeClass('visible');
        }
    }

    return {
        init() {
            moveStickyBar();
            // timeout needed for getBoundingClientRect() bugs in Safari
            setTimeout(checkVisibility, 100);
        },
        scroll() {
            checkVisibility();
        },
        resize() {
            checkVisibility();
        },
    };
})();

export default (() => {
    $(document).ready(stickyHeroButtonBar.init);

    $(window)
        .on('resize', debounce(stickyHeroButtonBar.resize, 600))
        .on('scroll', stickyHeroButtonBar.scroll);
})();
